<template>
	<div class="table-of-content">
		<AccordionItem icon="plus" :opened="true" :class="cardColor">
			<template #title>
				<h2 class="table-of-content__title">{{ title }}</h2>
			</template>
			<template #content>
				<div class="table-of-content__content">
					<div v-html="content" class="table-of-content__content__inner"></div>
				</div>
			</template>
		</AccordionItem>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const title = computed(() => props.fields?.title?.value);
const content = computed(() => props.fields?.content?.value);
const cardColor = computed(() => props.fields?.cardColor?.value);
</script>

<style lang="scss">
.table-of-content {
	margin: var(--spacing-8, 64px) var(--spacing-2, 16px) var(--spacing-2, 16px)
		var(--spacing-2, 16px);

	.table-of-content__title {
		font-family: var(--primary-font, sans-serif);
		font-size: var(--text-lg, 20px);
		font-weight: 300;
		line-height: 120%;
		padding: 0 var(--spacing-2, 16px);
	}

	.table-of-content__content {
		font-family: var(--primary-font, sans-serif);
		font-size: var(--text-sm, 14px);
		font-weight: 300;
		line-height: 140%;
		padding: 0 var(--spacing-2, 16px);

		p {
			margin-bottom: var(--spacing-3, 24px);
		}

		a {
			padding-bottom: var(--spacing-1, 8px);
			display: inline-block;
		}
	}

	.accordion-item {
		padding: var(--spacing-2, 16px);
		border-radius: 16px;
		box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25),
			0px 5px 15px 0px rgba(0, 0, 0, 0.25);
		background-color: #1b1b1b;
	}

	.accordion-item__button {
		padding: 0 !important;
	}

	.accordion-item {
		&,
		&.default,
		&.primary {
			background-color: var(--primary-color, #000);

			.accordion-item__content {
				color: var(--color-white, #fff);
			}
		}

		&.secondary {
			background-color: var(--secondary-color, #000);
			.accordion-item__content {
				color: var(--color-white, #fff);
			}
		}

		&.tertiary {
			background-color: var(--tertiary-color, #000);
			.accordion-item__content {
				color: var(--color-white, #fff);
			}
		}

		&.grey {
			background-color: var(--color-grey, #282828);
			.accordion-item__content {
				color: var(--color-white, #fff);
			}
		}

		&.white {
			background-color: var(--color-white, #fff);
			.accordion-item__content {
				color: var(--color-white, #000);
			}
		}
	}
}
</style>
